"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fragments_1 = require("../fragments");
const notifi_axios_utils_1 = require("@notifi-network/notifi-axios-utils");
const DEPENDENCIES = [
    ...fragments_1.telegramTargetFragmentDependencies,
    fragments_1.telegramTargetFragment,
];
const MUTATION = `
mutation createTelegramTarget(
  $name: String!
  $value: String!
) {
  createTelegramTarget(
    createTargetInput: {
      name: $name
      value: $value
    }
  ) {
    ...telegramTargetFragment
  }
}
`.trim();
const createTelegramTargetImpl = (0, notifi_axios_utils_1.makeRequest)((0, notifi_axios_utils_1.collectDependencies)(...DEPENDENCIES, MUTATION), 'createTelegramTarget');
exports.default = createTelegramTargetImpl;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3JlYXRlVGVsZWdyYW1UYXJnZXRJbXBsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vbGliL211dGF0aW9ucy9jcmVhdGVUZWxlZ3JhbVRhcmdldEltcGwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSw0Q0FHc0I7QUFDdEIsMkVBRzRDO0FBTTVDLE1BQU0sWUFBWSxHQUFHO0lBQ25CLEdBQUcsOENBQWtDO0lBQ3JDLGtDQUFzQjtDQUN2QixDQUFDO0FBRUYsTUFBTSxRQUFRLEdBQUc7Ozs7Ozs7Ozs7Ozs7O0NBY2hCLENBQUMsSUFBSSxFQUFFLENBQUM7QUFFVCxNQUFNLHdCQUF3QixHQUFHLElBQUEsZ0NBQVcsRUFHMUMsSUFBQSx3Q0FBbUIsRUFBQyxHQUFHLFlBQVksRUFBRSxRQUFRLENBQUMsRUFBRSxzQkFBc0IsQ0FBQyxDQUFDO0FBRTFFLGtCQUFlLHdCQUF3QixDQUFDIn0=